export default __webpack_public_path__ + "static/media/circle.8a169b7d.svg";